export const defineMutation = definition => Object.freeze(definition);